import { FutureMoneyLogo } from "./FutureMoneyLogo";
import { Container } from "./styles";

export const Header = () => {
  return (
    <>
      <Container>
        <FutureMoneyLogo />
      </Container>
    </>
  );
};
